import { create } from "zustand";
import { persist } from "zustand/middleware";

export type OsEnv = "sandbox" | "production";

type EnvState = {
  env: OsEnv | null;
  setEnv: (e: OsEnv) => void;
  clearEnv: () => void;
};

export const useEnvStore = create<EnvState>()(
  persist(
    (set) => ({
      env: null,
      setEnv: (e) => set({ env: e }),
      clearEnv: () => set({ env: null }),
    }),
    { name: "sc-os-env" },
  ),
);

export const getEnv = (): OsEnv | null => useEnvStore.getState().env;